// extracted by mini-css-extract-plugin
export default {"root":"osnzNO","box":"ISMn_L","title":"OHSXtk","subtitle":"AAEjsz","mainButton":"NCWmAZ","secondaryButton":"Z1sjR7","disclaimer":"yY8ZoD"};